<template>
  <span>
    <v-data-table
      :headers="headers"
      :items="cargoes"
      :search="search"
      sort-by="arrivaldate"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!--<v-toolbar-title>Cargo List </v-toolbar-title>-->
          <div class="flex-grow-1"></div>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
          <v-dialog v-model="dialog" max-width="700px">
           
              <template v-slot:activator="{ on }">
                <!---<v-btn color="primary" dark class="mb-2" v-on="on">Add</v-btn>-->
                <v-btn class="mx-2" fab small dark color="indigo" v-on="on">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
              </template>
               <v-form ref="cargoForm" lazy-validation v-model="valid">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                        v-for="header in headers"
                        :key="header.value"
                      >
                        <v-text-field
                          v-if="
                            header.value != 'action' &&
                              header.type != 'dateArrival' &&
                              header.type != 'dateDelivery' &&
                              header.type != 'textarea' &&
                              header.type != 'selectCS' &&
                              header.type != 'selectCargoType' &&
                              header.type != 'selectConsignee'
                          "
                          v-model="editedItem[header.value]"
                          :label="header.text"
                          :rules="[v => !!v || 'Item is required']"
                          required
                        ></v-text-field>
                        <v-autocomplete
                          v-if="header.type === 'selectConsignee'"
                          :items="consignees"
                          v-model="editedItem[header.id]"
                          item-text="name"
                          item-value="id"
                          :label="header.text"
                          auto-select-first
                          no-data-text="not available, please add..."
                        ></v-autocomplete>
                        <v-menu
                          v-model="menu"
                          v-if="header.type === 'dateArrival'"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="doa"
                              v-if="header.type === 'dateArrival'"
                              :label="header.text"
                              prepend-icon="mdi mdi-calendar"
                              readonly
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="doa"
                            @input="menu = false"
                          ></v-date-picker>
                        </v-menu>
                        <v-textarea
                          v-if="header.type === 'textarea'"
                          filled
                          :label="header.text"
                          v-model="editedItem[header.value]"
                          required
                          :rules="[v => !!v || 'Item is required']"
                        ></v-textarea>
                        <v-select
                          v-if="header.type === 'selectCargoType'"
                          :items="cargo_types"
                          v-model="editedItem[header.id]"
                          item-text="c_type_name"
                          item-value="c_type_id"
                          auto-select-first
                          :label="header.text"
                          required
                          :rules="[v => !!v || 'Item is required']"
                        ></v-select>
                        <v-select
                          v-if="header.type === 'selectCS'"
                          :items="cargo_size"
                          v-model="editedItem[header.value]"
                          :label="header.text"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <!--  <v-icon
        small
        class="mdi mdi-border-color"
        @click="editItem(item)"
      ></v-icon> -->
        <!--<v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon>-->

        <v-menu bottom left>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" outlined fab x-small dark v-on="on">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item v-for="(it, i) in menu_items" :key="i">
              <v-list-item-title
                style="cursor: pointer;"
                @click="menuAction({ name: it.ref, item: item })"
                >{{ it.title }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
      <template v-slot:item.arrivaldate="{ item }">
        <span>{{ item.arrivaldate | formatShortDate }}</span>
      </template>
      <template v-slot:item.deliverydate="{ item }">
        <span>{{ item.deliverydate | formatShortDate }}</span>
      </template>
    </v-data-table>
    <v-dialog
      ref="dlgDate"
      v-model="modal_date"
      :return-value.sync="date"
      persistent
      width="290px"
    >
      <v-date-picker v-model="date" scrollable>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="modal_date = false">Cancel</v-btn>
        <v-btn text color="primary" @click="setDate()">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";

export default {
  name: "CargoListDataTable",
  props: ["manifestID"],
  data: () => ({
    valid: false,
    dialog: false,
    modal_date: false,
    show: false,
    search: "",
    menu: null,
    selected_menu_item: [],
    cargo_types: [],
    consignees: [],
    selected_item: [],
    cargo_size: [0, 20, 40, 45],
    doa: new Date().toISOString().substr(0, 10),
    dod: new Date().toISOString().substr(0, 10),
    date: new Date().toISOString().substr(0, 10),
    rules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters"
    },
    menu_items: [
      { title: "edit", ref: "edit" },
      { title: "add delivery date", ref: "delivery_date" },
      { title: "add returned date", ref: "return_date" },
      { title: "add vacate date", ref: "vacate_date" }
    ],
    headers: [
      {
        text: "Cargo Type",
        value: "c_type_name",
        type: "selectCargoType",
        id: "c_type_id"
      },
      {
        text: "Container no",
        align: "left",
        sortable: false,
        value: "containernumber",
        required: ["Required"]
      },
      {
        text: "Consignee",
        value: "consignee_name",
        type: "selectConsignee",
        id: "consignee_id"
      },

      { text: "Seal no", value: "sealnumber", required: ["Required"] },
      { text: "Cargo Size", value: "cargosize", type: "selectCS" },
      {
        text: "Grossweight (KG)",
        value: "gross_weight",
        required: ["Required"]
      },
      { text: "Arrival Date", value: "arrivaldate", type: "dateArrival" },
      {
        text: "Description",
        value: "description",
        type: "textarea",
        required: ["Required"]
      },
      { text: "Delivery Date", value: "deliverydate", type: "dateDelivery" },
      { text: "Actions", value: "action", sortable: false }
    ],
    manifest_id: null,
    editedIndex: -1,
    editedItem: {
      c_type_name: "",
      consignee_name: "",
      //other_consignees: "",
      containernumber: "",
      sealnumber: "",
      cargosize: "",
      grossweight: "",
      arrivaldate: "",
      deliverydate: "",
      description: ""
    },
    defaultItem: {
      c_type_name: "",
      consignee_name: "",
      containernumber: "",
      //other_consignees: "",
      sealnumber: "",
      cargosize: "",
      grossweight: "",
      arrivaldate: "",
      deliverydate: "",
      description: ""
    }
  }),

  computed: {
    ...mapState({
      cargoes: state => state.cargoes.cargoes
    }),
    formTitle() {
      return this.editedIndex === -1
        ? "Add Cargo"
        : "Edit " + this.editedItem.containernumber;
    }
  },

  watch: {
    dialog(val) {
      val || this.close();

      if (val) {
        this.$store.dispatch("cargoes/fetchAllCargoTypes").then(res => {
          this.cargo_types = res;
        });
        this.$store.dispatch("consignees/fetchConsignees").then(res => {
          this.consignees = res;
        });
      }
    },
    manifestID(val) {
      this.$store.dispatch("cargoes/fetchCargoesByManID", val);
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("cargoes/fetchCargoesByManID", this.manifestID);
    },
    showAlert(obj) {
      alert(obj.message);
    },
    menuAction(obj) {
      let _id = obj.item.id;
      if (obj.name === "return_date") {
        this.selected_menu_item = obj.name;
        this.showDialog(obj.item);
      } else if (obj.name === "edit") {
        this.editItem(obj.item);
      } else if (obj.name === "delivery_date") {
        this.selected_menu_item = obj.name;
        this.showDialog(obj.item);
      } else {
        this.selected_menu_item = obj.name;
        this.showDialog(obj.item);
      }
    },
    showDialog(item) {
      if (item) {
        this.selected_item = item;
      } else {
        return;
      }
      this.modal_date = true;
    },
    setDate() {
      if (!this.selected_menu_item) return;

      if (this.selected_menu_item === "delivery_date") {
        this.setDeliveryDate();
      } else if (this.selected_menu_item === "return_date") {
        this.setReturnDate();
      } else if (this.selected_menu_item === "vacate_date") {
        this.setVacateDate();
      } else {
        return;
      }
    },

    setReturnDate() {
      //console.log("return date");
      //console.log(this.selected_item);
      this.showAlert({ message: "Function not available!" });
    },
    setDeliveryDate() {
      //console.log("delivery date");
      // console.log(this.selected_item);
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, set!"
        })
        .then(result => {
          if (result.value) {
            this.modal_date = false;

            //console.log(moment(String(this.date_departure)).format("l"));
            this.$store
              .dispatch("cargoes/setDeliveryDate", {
                id: this.selected_item.id,
                item: {
                  deliverydate: moment(String(this.date)).format("l")
                }
              })
              .then(res => {
                if (res.success) {
                  this.$swal.fire("Date Set!", res.success, "success");
                  this.initialize();
                } else {
                  this.$swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: res.error
                  });
                  return;
                }
              });
          }
        });
    },
    setVacateDate() {
      //console.log("vacate date");
      //console.log(this.selected_item);
      this.showAlert({ message: "Function not available!" });
    },

    editItem(item) {
      this.editedIndex = this.cargoes.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.arrivaldate) {
        this.doa = moment(this.editedItem.arrivaldate).format("YYYY-MM-DD");
      } else {
        this.doa = new Date().toISOString().substr(0, 10);
      }
      this.dialog = true;
    },

    deleteItem(item) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.$store
              .dispatch("shipping_lines/deleteLine", item)
              .then(res => {
                if (res.success) {
                  this.$swal.fire("Deleted!", res.success, "success");
                  this.initialize();
                } else this.$noty.warning(res.error);
              });
          }
        });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (!this.$refs.cargoForm.validate()) return;
      if (this.editedIndex > -1) {
        // Object.assign(lines[this.editedIndex], this.editedItem)
        let data = {
          id: this.editedItem.id,
          consignee_id: this.editedItem.consignee_id,
          c_type_id: this.editedItem.c_type_id,
          manifest_id: this.manifestID,
          sealnumber: this.editedItem.sealnumber,
          cargosize: this.editedItem.cargosize,
          description: this.editedItem.description,
          gross_weight: this.editedItem.gross_weight,
          containernumber: this.editedItem.containernumber,
          arrivaldate: moment(String(this.doa)).format("l"),
          // deliverydate: null,
          status: 0,
          is_transit: 0
        };

        this.$store.dispatch("cargoes/updateCargo", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else this.$noty.warning(res.error);
          return;
        });
      } else {
        let data = {
          // id: this.editedItem.id,
          consignee_id: this.editedItem.consignee_id,
          c_type_id: this.editedItem.c_type_id,
          manifest_id: this.manifestID,
          sealnumber: this.editedItem.sealnumber,
          cargosize: this.editedItem.cargosize,
          description: this.editedItem.description,
          gross_weight: this.editedItem.gross_weight,
          containernumber: this.editedItem.containernumber,
          arrivaldate: moment(String(this.doa)).format("l"),
          // deliverydate: null,
          status: 0,
          is_transit: 0
        };

        console.log(data);

        this.$store.dispatch("cargoes/saveCargo", data).then(res => {
          if (res.success) {
            this.initialize();
            this.$noty.success(res.success);
          } else this.$noty.warning(res.error);
          return;
        });
      }
      this.close();
    }
  }
};
</script>
